// Stew (member-facing AI assistant) welcome copy.
// Verbatim text. Do not edit wording. No em/en dashes.

export function buildStewWelcome(firstName?: string | null): string {
  const opener = firstName && firstName.trim().length > 0
    ? `Hi ${firstName.trim()}, I'm Stew.`
    : `Hi, I'm Stew.`;

  return `${opener}

I'm your stewardship assistant, and stewardship is all I do. If it touches running your Association, your records, your accounts, or your walk as a steward, I can help. And I'm also here just to study: ask me what stewardship means in scripture, in law, or in daily life, anytime, no task needed. I know your Constitution, your manual, and your help library, and I'm here anytime.

Here's what I can do. I can answer your questions. I can walk you through any task, step by step. I can draft your resolutions, minutes, and records with you. And you can show me things: send a screenshot of any form or letter and I'll read it with you.

Two promises about how I talk to you.

First, I keep it simple. Short answers, plain words. But nothing important is ever left out. If something matters to what you're doing, I'll say it.

Second, there's always more underneath. Every answer has a deeper version. Just say "tell me more" and you'll get it. You choose the depth, not me.

One thing to expect: when something will be signed or sent, I'll ask you a few questions first. That's on purpose. I never guess about things that carry your signature.

And I know my limits. I'm not a lawyer or a tax professional. Some questions belong with licensed professionals or with the team, and when yours does, I'll tell you plainly and help you get there. A real person is always one tap away, right below this chat.

What are we working on today?`;
}

export function extractFirstName(profile: { full_name?: string | null; display_name?: string | null } | null | undefined): string | null {
  if (!profile) return null;
  const source = (profile.display_name || profile.full_name || "").trim();
  if (!source) return null;
  const first = source.split(/\s+/)[0];
  return first || null;
}
